import styled from 'styled-components'
import GoodSVG from '../../assets/status/good.svg?react'
import NeutralSVG from '../../assets/status/neutral.svg?react'
import BadSVG from '../../assets/status/bad.svg?react'
import { useTranslation } from "react-i18next"

const Card = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  padding: 8px 8px;
  height: 70px;
  border: 1px solid #d6d7db;
  border-radius: 8px;
`

const TextContainer = styled.div`
  flex: 1;
  margin-left: 16px;
`


const AlertStatusCard = ({ alertStatus }) => {
  const { t } = useTranslation('common')
  const status = {
    good: {
      svg: (
        <GoodSVG
          width={60}
          height={60}
        />
      ),
      text: `${t('dashboard.header.status.good.text')}.` ,
      color: '#428262',
    },
    regular: {
      svg: (
        <NeutralSVG
          width={60}
          height={60}
        />
      ),
      text: `${t('dashboard.header.status.regular.text')}.`,
      color: '#B26D1D',
    },
    bad: {
      svg: (
        <BadSVG
          width={60}
          height={60}
        />
      ),
      text: `${t('dashboard.header.status.bad.text')}.`,
      color: '#BE3756',
    },
  }

  return (
    <Card>
      <div>{status[alertStatus]?.svg}</div>
      <TextContainer>
        <span style={{ fontSize: 18 }}>
          {t('dashboard.header.status.description')}
          <span style={{ fontWeight: 600, color: status[alertStatus]?.color }}>
            {t(`${status[alertStatus]?.text}`)}
            {}
          </span>
        </span>
      </TextContainer>
    </Card>
  )
}

export default AlertStatusCard
